var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenericList',{attrs:{"caption":"Seller Offers Applications","items":_vm.pendingRequests,"fields":_vm.fields,"is-loading":_vm.isLoading,"action-uri":_vm.actionUri},on:{"change-auto-reload":_vm.onChangeAutoReload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }